import { useEffect, useRef } from "react";
import { ContactAndSchedule } from "./ContactAndSchedule";
import ContactForm from "./ContactForm";
import { UnderConstruction } from "./UnderConstruction";

function Contact() {
    const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])
    return <>
    
    <div className="font-[Montserrat] w-[80%] grid grid-cols-1 gap-2 md:grid-cols-2">
      <div ref={containerRef} className="h-full p-8 drop-shadow-lg  md:w-[100%] bg-[#F3F3F3] text-[#212121] flex flex-col items-center mt-5 hover:border-[3px] hover:border-[#4CB117] hover:text-[#212121]">
         <p className="w-full text-[#4CB117] font-extrabold text-2xl text-left py-3">Need help? Our team is always here to assist you</p>
         <p className='w-full text-[#212121] text-left text-sm'>Send a message using the form.</p>
           
        <ContactForm />

      
      </div>
      <div ref={containerRef} className="h-full p-8 drop-shadow-lg md:w-[100%] bg-[#F3F3F3] text-[#212121] flex flex-col items-center mt-5 hover:border-[3px] hover:border-[#4CB117] hover:text-[#4CB117]">
        <div className="py-10 text-[#212121] flex flex-col items-start justify-start text-left">
          <p className='w-full text-[#212121] font-extrabold text-l text-left py-3'>Don’t hesitate to reach out with the contact information below</p>
              <ContactAndSchedule />
        </div>
      </div>
      </div>
    </>
  }
  
  export default Contact;